import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DeviceDetailsPage.css';

function DeviceDetailsPage({ data, updateData }) {
  const [formData, setFormData] = useState(data.deviceDetails || {
    phoneUsageDuration: '',
    phoneOwnership: '',
    phoneCondition: ''
  });
  
  const navigate = useNavigate();

  const usageOptions = [
    { value: '0-12', label: '0-12 months' },
    { value: '1-3', label: '1-3 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '5+', label: '5+ years' }
  ];

  const handleChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleContinue = () => {
    if (!formData.phoneUsageDuration || !formData.phoneOwnership || !formData.phoneCondition) {
      alert('Please provide all device details');
      return;
    }
    
    updateData('deviceDetails', formData);
    navigate('/identification');
  };

  return (
    <div className="device-details-page">
      <div className="container">
        <div className="page-header">
          <h2>Device Details</h2>
          <p>Tell us about your mobile device</p>
        </div>

        <div className="device-form">
          <div className="form-group">
            <label>How long have you been using this phone number? *</label>
            <div className="options-grid">
              {usageOptions.map(option => (
                <button
                  key={option.value}
                  type="button"
                  className={`option-btn ${formData.phoneUsageDuration === option.value ? 'selected' : ''}`}
                  onClick={() => handleChange('phoneUsageDuration', option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Do you own this phone? *</label>
            <div className="radio-group">
              {['Yes, I own it', 'No, it\'s borrowed/shared'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="phoneOwnership"
                    value={option}
                    checked={formData.phoneOwnership === option}
                    onChange={(e) => handleChange('phoneOwnership', e.target.value)}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Phone condition when acquired *</label>
            <div className="radio-group">
              {['New - Bought brand new', 'Used - Second-hand purchase'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="phoneCondition"
                    value={option}
                    checked={formData.phoneCondition === option}
                    onChange={(e) => handleChange('phoneCondition', e.target.value)}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>

          <button 
            type="button"
            className="continue-btn"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeviceDetailsPage;